import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import MyDialog from '../components/MyDialog';
import useForm from '../hooks/useForm';
import { useNavigate, useParams } from 'react-router-dom';
import WebService from '@util/webService';
import { FormControl, InputLabel, Input, FormHelperText, Alert, Grid, Container, Box, Typography, Stack } from '@mui/material';
import HandymanOutlinedIcon from '@mui/icons-material/HandymanOutlined';


const RepairPage = () => {
  const navigate = useNavigate()
  const {message} = useParams()
  console.log('message=>', message)
  const fetchCodes = async() => {
    const url = '/config'
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      navigate('/')
    }
  }

  React.useEffect(() => {
    fetchCodes()
  }, [])

  return (
    <Container maxWidth="sm" style={{marginTop:100,}}>
      <Box>
        <Grid container spacing={3} sx={{display:'flex', flexDirection:'column', justifyConent:'center', alignItems:'center'}}>
          <Grid item xs={12}>
            <HandymanOutlinedIcon sx={{fontSize:100}}/>
          </Grid>
          <Grid item xs={12}>
            <Typography variant='h5'>
              서비스 점검 중...
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{display:'flex'}}>

            {
              message ? (
                <>
                  <Typography>
                    작업 시간:
                  </Typography>
                  <Typography style={{fontWeight:'bold', marginLeft:10}}>
                    {message}
                  </Typography>
                </>

              ) : null
            }

          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

export default RepairPage
